import React from "react";

/**
 * Nina — mascote do assistente do AutoPost BR.
 *
 * Usa o sprite sheet real (nina-sprite.png, em /public), 4 quadros lado a
 * lado: parado / lambendo / mais lambida / voltando. Técnica clássica de
 * sprite de jogo antigo: um background-image só, animado via
 * background-position em degraus (steps), sem trocar de elemento.
 *
 * Estados:
 *   idle (padrão)  → looping pelos 4 quadros, a Nina se lambendo
 *   hover           → pausa no quadro 1 (parado) e mostra um coraçãozinho
 *
 * Proporção do frame original: 168x205px (~0.82:1). O componente calcula a
 * largura a partir da altura pedida pra não distorcer o sprite.
 */

const FRAME_RATIO = 173 / 217; // largura / altura de cada quadro (sprite com fundo removido)
const SPRITE_URL = "/nina-sprite.png";

export default function Nina({ size = 40, className = "", state = "auto" }) {
  const height = size;
  const width = Math.round(size * FRAME_RATIO);

  // "auto" deixa o CSS decidir pelo hover; "idle"/"happy" forçam um quadro
  // fixo (útil pra avatar estático, sem animação, ex. no cabeçalho do chat).
  const forced = state !== "auto" ? `nina--force-${state}` : "";

  return (
    <span
      className={`nina ${forced} ${className}`}
      style={{
        width,
        height,
        // 4 quadros lado a lado => 400% de largura total do sprite
        backgroundImage: `url(${SPRITE_URL})`,
        backgroundSize: "400% 100%",
      }}
      role="img"
      aria-label="Nina, assistente do AutoPost BR"
    />
  );
}
